export default "__VITE_ASSET__CeUc7sct__"